<template>
    <el-row class="ipblacklist container_self table_parent">
        <h3>IP 黑名单列表</h3>
        <el-row class="search_parent">
            <el-form :inline="true" size="mini" :model="queryParams" class="demo-form-inline queryForm">
                <el-form-item label="IP 地址">
                    <el-input v-model="queryParams.keyword" placeholder="请输入ip地址" clearable></el-input>
                </el-form-item>
                <el-form-item label="IP 状态">
                    <el-select v-model="queryParams.disabled" placeholder="请选择状态" clearable>
                        <el-option label="启用" :value="0"></el-option>
                        <el-option label="未启用" :value="1"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="开始时间">
                    <el-date-picker
                        v-model="queryParams.startTime"
                        type="datetime"
                        value-format="yyyy-MM-dd HH:mm:ss"
                        clearable
                        placeholder="选择开始时间">
                    </el-date-picker>
                </el-form-item>
                <el-form-item label="结束时间">
                    <el-date-picker
                        v-model="queryParams.endTime"
                        type="datetime"
                        value-format="yyyy-MM-dd HH:mm:ss"
                        clearable
                        placeholder="选择结束时间">
                    </el-date-picker>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="onSubmit">查询</el-button>
                </el-form-item>
            </el-form>
        </el-row>
        <el-table :data="blackList"  style="width: 100%" v-loading="loading">
           <el-table-column prop="id" label="ID" align="center" width="100"></el-table-column>
           <el-table-column label="IP地址" align="center" width="300">
                <template slot-scope="scope">
                    <el-tooltip content="点击查看此ip对应的域名" placement="top" effect="light">
                        <p style="cursor:pointer;margin:0;width:220px;display: inline-block;" @click="checkDomain(scope.row)">{{scope.row.ip}} </p>
                    </el-tooltip>
                </template>
           </el-table-column>
           <el-table-column label="是否启用" align="center" width="100">
                <template slot-scope="scope">
                     <span v-if="!scope.row.disabled">启用</span>
                     <span v-else>未启用</span>
                </template>
           </el-table-column>
           <el-table-column prop="source" label="问题来源" align="center"></el-table-column>
           <el-table-column prop="description" label="问题描述" align="center" width="400"></el-table-column>
           <el-table-column prop="createTime" label="创建时间" align="center"  width="400"></el-table-column>
           <el-table-column label="操作" align="center" width="180" fixed="right">
                <template slot-scope="scope">
                    <el-button type="success" size="mini" @click="setItem(scope.row)">设置</el-button>
                    <el-button type="danger" size="mini" @click="deleteItem(scope.row)">删除</el-button>
                </template>
           </el-table-column>
        </el-table>
        <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="queryParams.currentPage"
            :page-sizes="[50, 100, 200, 400]"
            :page-size="queryParams.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total">
        </el-pagination>


        <el-dialog title="设置黑名单" :visible.sync="dialogFormVisible">
            <el-form :model="setBlackList" size="mini">
                <el-form-item label="IP 地址" :label-width="formLabelWidth">
                    <el-input v-model="setBlackList.ip" autocomplete="off" disabled></el-input>
                </el-form-item>
                <el-form-item label="设置" :label-width="formLabelWidth">
                   <el-select v-model="setBlackList.action" placeholder="请选相关设置" clearable>
                        <el-option :value="1" label="启用"></el-option>
                        <el-option :value="2" label="未启用"></el-option>
                        <!-- <el-option :value="3" label="删除"></el-option> -->
                   </el-select>
                </el-form-item>
                <el-form-item label="问题描述" :label-width="formLabelWidth">
                    <!-- <el-input v-model="setBlackList.description" autocomplete="off"></el-input> -->
                    <el-select v-model="setBlackList.description">
                        <el-option value="IP集中" label="IP集中"></el-option>
                        <el-option value="Cloudflare反馈的IP集中" label="Cloudflare反馈的IP集中"></el-option>
                        <el-option value="其他原因" label="其他原因"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="IP问题来源" :label-width="formLabelWidth">
                    <el-input v-model="setBlackList.source" autocomplete="off"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogFormVisible = false">取 消</el-button>
                <el-button type="primary" @click="updateIpStatus">确 定</el-button>
            </div>
        </el-dialog>

        <el-dialog :title="'ip： '+checkedIp+' 访问的域名列表'" :visible.sync="domainVisible1" width="50%">
            <el-row>共 {{totalDomain}} 条</el-row>
            <el-table :data="iptoDomainList">
                <el-table-column label="域名" prop="domain" align="center"></el-table-column>
                <el-table-column label="访问次数" prop="total" align="center"></el-table-column>
            </el-table>
        </el-dialog>
    </el-row>
</template>

<script>
    import {axiosGet,axiosPost} from '@/assets/ajaxFn'
    export default {
        data(){
            return{
                loading:false,
                checkedIp:"",
                iptoDomainList:[],
                domainVisible1:false,
                blackList:[],
                queryParams:{
                    currentPage:1,
                    disabled:0,
                    endTime:"",
                    keyword:"",
                    pageSize:50,
                    startTime:""
                },
                setBlackList:{
                    action:0,
                    description:"",
                    ip:"",
                    source: "",
                },
                total:0,
                dialogFormVisible:false,
                formLabelWidth:"80px",
                totalDomain:0,
            }
        },
        methods: {
            getList(params){
                if(params.keyword){
                    params.keyword=params.keyword.trim();
                }
                axiosGet("/api/ip_fraud_rate/ipblack_list",params).then(res=>{
                    if(res.code==0){
                        this.total=res.data.total;
                        this.blackList=res.data.records;
                    }
                })
            },
            checkDomain(row){
                // 获取今天的日期
                const today = new Date();

                // 获取目标日期
                const targetDate = new Date(row.createTime); // 这里是目标日期，可以根据需要修改

                // 比较日期是否相同
                const isToday = today.toDateString() === targetDate.toDateString();

                if (isToday) {
                    this.$message({message:'当天数据无法查询，请隔天查询',type:'warning'});
                   return false;
                }
                this.loading=true;
                axiosGet('/api/ip_fraud_rate/domain_count',{ip:row.ip,startDate:row.createTime,endDate:row.createTime}).then(res=>{
                    if(res.code==0){
                        this.iptoDomainList=res.data;
                        this.checkedIp=row.ip;
                        this.totalDomain=res.data.length;
                        this.domainVisible1=true;
                        this.loading=false;
                    }else{
                        this.loading=false;
                    }
                })
                
            },
            onSubmit(){
                this.queryParams.currentPage=1;
                this.getList(this.queryParams);
            },
            handleSizeChange(val){//下拉翻页
                this.queryParams.pageSize=val;
                this.getList(this.queryParams);
            },
            handleCurrentChange(val){//页码翻页
                this.queryParams.currentPage=val;
                this.getList(this.queryParams);
            },
            setItem(item){
                this.setBlackList={
                    ip:item.ip,
                    source: item.source,
                    action:parseInt(item.disabled)+1,
                    description:item.description
                };
                this.dialogFormVisible=true;
                console.log(item);
            },
            deleteItem(row){
                this.$confirm('请确认是否要从黑名单里删除此IP?', '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                    }).then(() => {
                        axiosPost('/api/ip_fraud_rate/add_ipblack',{action:3,ip:row.ip},"JSON").then(res=>{
                           if(res.code==0){
                                this.$message({
                                    type: 'success',
                                    message: '删除成功!'
                                });
                            this.getList(this.setBlackList);   
                           }
                        })
                    }).catch(() => {});
            },
            updateIpStatus(){
                if(!this.setBlackList.action){
                    this.$message({message:"请先选择需要进行的设置",type:"error"}); 
                    return false;
                }
                let _this=this;
                axiosPost('/api/ip_fraud_rate/add_ipblack',_this.setBlackList,"JSON").then(res=>{
                    if(res.code==0){
                        _this.getList(_this.setBlackList);
                        _this.$message({message:"设置成功",type:"success"});
                        
                        _this.dialogFormVisible=false;
                    }else{
                        _this.$message({message:res.message,type:"error"});
                        _this.dialogFormVisible=false;
                    }
                })
            }
        },
        mounted() {
            this.getList(this.queryParams)
        },
    }
</script>

<style scope>
    .queryForm{
        width: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;
    }
</style>


// WEBPACK FOOTER //
// src/components/view/IpManager/blacklist.vue